
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/atmmachineprices/privacy-policy",
      function () {
        return require("private-next-pages/atmmachineprices/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/atmmachineprices/privacy-policy"])
      });
    }
  